export default "__VITE_ASSET__689bb0e8__"